"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var immutable_1 = require("immutable");
var Agents = require("@findify/agent");
var analytics_1 = require("@findify/analytics");
var symbols_1 = require("../symbols");
var prop_types_1 = require("prop-types");
var agents = {};
exports.createProvider = function (type, onCreate) {
    return _a = (function (_super) {
            __extends(Provider, _super);
            function Provider(props, context) {
                var _this = _super.call(this, props, context) || this;
                _this.setQuery = function (query) {
                    for (var key in query)
                        _this.agent.set(key, query[key]);
                };
                _this.update = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    (_a = _this.agent).update.apply(_a, args);
                    var _a;
                };
                var apiKey = props.apiKey, agent = props.agent, options = props.options, defaults = props.defaults, config = props.config;
                var _key = agent && agent.config.key || apiKey;
                var _config = config || immutable_1.Map();
                var analyticsConfig = __assign({ key: _key, events: _config.get('analytics', immutable_1.Map()).toJS() }, _config.get('platform', immutable_1.Map()).toJS());
                _this.nested = context[symbols_1.$findify];
                if (agent && !agent.config.immutable) {
                    throw new Error("\n          Agent should be in \"immutable\" mode, to work with connectors.\n          Add \"immutable: true\" to your Agent initializer\n        ");
                }
                _this.storeKey = _this.props.storeKey;
                _this.analytics = analytics_1.default(analyticsConfig);
                _this.state = { config: _config };
                _this.agent = agent || new Agents[type](__assign({ key: _key, user: _this.analytics.user, immutable: true }, options));
                if (_this.storeKey)
                    agents[_this.storeKey] = _this.agent;
                if (onCreate)
                    onCreate(_this.agent);
                if (defaults)
                    _this.agent.defaults(defaults);
                return _this;
            }
            Provider.prototype.getChildContext = function () {
                return _a = {},
                    _a[symbols_1.$analytics] = this.analytics,
                    _a[symbols_1.$config] = this.state.config,
                    _a[symbols_1.$findify] = __assign({}, agents, this.nested, (!this.storeKey && { default: this.agent })),
                    _a;
                var _a;
            };
            Provider.prototype.componentWillReceiveProps = function (next) {
                var _this = this;
                if (typeof next.query !== 'object' ||
                    this.props.query === next.query ||
                    Object.keys(next.query).every(function (k) {
                        return immutable_1.is(_this.props.query[k], next.query[k]);
                    }))
                    return;
                this.setQuery(next.query);
                if (!!next.agent && next.agent !== this.agent) {
                    this.agent = next.agent;
                    this.forceUpdate();
                }
            };
            Provider.prototype.componentDidMount = function () {
                if (this.props.onChangeQuery) {
                    this.agent.on('change:query', this.props.onChangeMeta);
                }
            };
            Provider.prototype.componentWillUnmount = function () {
                if (this.props.onChangeMeta)
                    this.agent.off(this.props.onChangeMeta);
                if (this.storeKey)
                    agents[this.storeKey] = null;
            };
            Provider.prototype.render = function () {
                return this.props.children;
            };
            return Provider;
        }(react_1.PureComponent)),
        _a.propTypes = {
            apiKey: prop_types_1.string,
            agent: prop_types_1.object,
            defaults: prop_types_1.object,
            options: prop_types_1.object,
            config: prop_types_1.object,
            onChangeQuery: prop_types_1.func,
            storeKey: prop_types_1.oneOfType([prop_types_1.string, prop_types_1.number]),
            query: prop_types_1.object
        },
        _a.contextTypes = (_b = {},
            _b[symbols_1.$findify] = prop_types_1.object,
            _b),
        _a.childContextTypes = (_c = {},
            _c[symbols_1.$findify] = prop_types_1.object.isRequired,
            _c[symbols_1.$analytics] = prop_types_1.object.isRequired,
            _c[symbols_1.$config] = prop_types_1.object.isRequired,
            _c),
        _a;
    var _a;
    var _b, _c;
};
//# sourceMappingURL=createProvider.js.map